export const MODE_CREATE = 'create_mod';
export const MODE_UPDATE = 'update_mod';
export const MODE_BOOKING = 'booking_mod';
export const MODE_DELETE = 'delete_mod';
